/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';

import Styled from './styled';
import ErrorAwareImage from '../ErrorAwareImage';
import IconButton from '../IconButton';
import placeholderImage from '../../assets/images/protones-placeholder-1.png';

import type { Translate } from '../../types';

type Props = {
  imgSrc: any,
  title: string,
  subTitle?: string,
  description: string,
  trackSrc?: string,
  onTogglePlay?: any => any,
  isPlaying?: boolean,
  onClick: any => any,
  t: Translate,
};

class Smartilst extends React.PureComponent<Props, void> {
  // API HTML Audio
  audio: HTMLAudioElement = document.createElement('audio');
  audioEndedListener = this.props.onTogglePlay || (() => {});

  componentDidMount() {
    this.audio.addEventListener('ended', this.audioEndedListener);
  }

  componentWillUnmount() {
    this.audio.removeEventListener('ended', this.audioEndedListener);
    this.audio.pause();
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.isPlaying != null && prevProps.isPlaying !== this.props.isPlaying) {
      if (this.props.isPlaying) {
        this._playAudio();
      } else {
        this._pauseAudio();
      }
    }
  }

  _playAudio = async () => {
    try {
      this.audio.setAttribute('src', this.props.trackSrc);
      await this.audio.play();
    } catch (error) {
      console.warn(`Audio playback failed at ${new Date().toLocaleTimeString()}`);
    }
  };

  _pauseAudio = () => {
    if (!this.audio) {
      return;
    }
    this.audio.pause();
    this.audio.removeAttribute('src');
  };

  _onTogglePlay = (event: any) => {
    event.stopPropagation();
    this.props.onTogglePlay && this.props.onTogglePlay(event);
  };

  render() {
    const { imgSrc, title, subtitle, trackSrc, description = '', onClick, t } = this.props;
    const ellipsedDescription =
      description.length < 50 ? description : description.slice(0, 47) + '...';
    return (
      <Styled.Container onClick={onClick ? () => onClick(this.props) : undefined}>
        <Styled.Content>
          <ErrorAwareImage
            src={imgSrc || placeholderImage}
            alt={title}
            style={{
              display: 'block',
              width: '100%',
              height: '170px',
              border: 0,
            }}
          />
          <Styled.Overlay>
            <Styled.Title>{title}</Styled.Title>
            {trackSrc && (
              <IconButton
                size={'large'}
                icon={this.props.isPlaying ? 'pause' : 'play'}
                tooltip={this.props.isPlaying ? t('PLAYING') : t('PAUSED')}
                onClick={this._onTogglePlay}
              />
            )}
            {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
            <Styled.Info>{ellipsedDescription}</Styled.Info>
          </Styled.Overlay>
        </Styled.Content>
      </Styled.Container>
    );
  }
}

export default withTranslation()(Smartilst);
